import React from 'react'
import './loading.css'

function Loading() {
  return (
    <div className = "loading__container">
      <div className="loading"></div>
    </div>
  )
}

export default Loading
